import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { hrSubUrl } from '../catalog';
import { AuditTrail, Dashboard, Drafts, Reports } from './hrrc/Lists';
import AllRequests from './hrrc/AllRequests';
import NewRequest from './hrrc/NewRequest';
import Settings from './hrrc/Settings';
import AdvancedRequests from './hrrc/adv/AdvancedRequests';
import { Banner, useHrrcMeta } from './hrrc/shared';
import Loader from '../components/Loader';

// HR & People > HR Request Center (Stephanet's custom/HRRequestCenter.jsx): one screen whose tab is the sub-module's `tab`.
// Each tab is its own sub-module so the group bar, the address and the access checks work as for the other HR menus. Advanced is
// its own requisition system with its own left navigation and data (hrrc/adv).

const TABS = {
  dashboard: ['HR Request Center', 'Raise, route and track HR requests across every HR module', Dashboard],
  new: ['New Request', 'Pick a module and request type, fill in the details and submit for approval', NewRequest],
  drafts: ['Drafts', 'Requests saved as drafts and those sent back for correction', Drafts],
  all: ['All Requests', 'Every request you raised, those waiting for you, and (with View All) everyone else\'s', AllRequests],
  reports: ['Reports', 'Requests by module and status over a period', Reports],
  audit: ['Audit Trail', 'Every action on a request: this module\'s events and the approval steps', AuditTrail],
  settings: ['Settings', 'Number format, required fields, SLA and approval routes per request type', Settings],
};

export default function HRRequestCenter({ sub }) {
  if (sub.tab === 'advanced') return <AdvancedRequests />;
  return <RequestDesk sub={sub} />;
}

function RequestDesk({ sub }) {
  const navigate = useNavigate();
  const { meta, error, reload } = useHrrcMeta();
  const [title, text, Tab] = TABS[sub.tab] || TABS.dashboard;
  return (
    <div className="hrc">
      <Banner title={title} text={text}>
        {sub.tab !== 'new' && meta?.can.create && <button className="mds-run" onClick={() => navigate(hrSubUrl('hrrc-new'))}><Plus size={15} /> New Request</button>}
      </Banner>
      {error && <div className="error">{error}</div>}
      {!meta && !error && <Loader title="Loading…" />}
      {meta && <Tab meta={meta} onSaved={reload} />}
    </div>
  );
}
